/** AUTH57 Slice B — snapshot freshness (client clock). */

export const OFFLINE_STALE_AFTER_MS = 6 * 60 * 60 * 1000;
export const OFFLINE_EXPIRE_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

export const OFFLINE_FRESHNESS = Object.freeze({
  FRESH: 'fresh',
  STALE: 'stale',
  EXPIRED: 'expired',
  INVALID: 'invalid',
});

export const OFFLINE_READ_COPY = Object.freeze({
  bannerTitle: '目前離線，顯示上次更新的行程資料',
  lastUpdatedPrefix: '上次更新',
  staleHint: '資料可能已過時，連上網路後請重新整理。',
  expiredTitle: '快取行程已過期',
  expiredBody: '請連上網路後重新載入最新行程。',
  networkRequired: '需要網路連線',
  todayNotCached: '今日資料尚未快取，需要網路連線',
  retry: '重新連線並載入',
});

/**
 * @param {string|null|undefined} fetchedAt
 * @param {number} [nowMs]
 * @returns {'fresh'|'stale'|'expired'|'invalid'}
 */
export function evaluateOfflineFreshness(fetchedAt, nowMs = Date.now()) {
  if (fetchedAt == null || fetchedAt === '') return OFFLINE_FRESHNESS.INVALID;
  const parsed = Date.parse(String(fetchedAt));
  if (!Number.isFinite(parsed)) return OFFLINE_FRESHNESS.INVALID;
  const age = nowMs - parsed;
  if (age < 0) {
    // Clock skew: treat as fresh but not future-trusted beyond expire window from |age|
    if (Math.abs(age) > OFFLINE_EXPIRE_AFTER_MS) return OFFLINE_FRESHNESS.INVALID;
    return OFFLINE_FRESHNESS.FRESH;
  }
  if (age >= OFFLINE_EXPIRE_AFTER_MS) return OFFLINE_FRESHNESS.EXPIRED;
  if (age >= OFFLINE_STALE_AFTER_MS) return OFFLINE_FRESHNESS.STALE;
  return OFFLINE_FRESHNESS.FRESH;
}

export function isOfflineSnapshotRenderable(fetchedAt, nowMs = Date.now()) {
  const freshness = evaluateOfflineFreshness(fetchedAt, nowMs);
  return freshness === OFFLINE_FRESHNESS.FRESH || freshness === OFFLINE_FRESHNESS.STALE;
}

export function formatOfflineFetchedAt(fetchedAt) {
  if (fetchedAt == null || fetchedAt === '') return '';
  const parsed = Date.parse(String(fetchedAt));
  if (!Number.isFinite(parsed)) return '';
  try {
    return new Intl.DateTimeFormat('zh-TW', {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(new Date(parsed));
  } catch {
    return String(fetchedAt);
  }
}
